export enum SubscriptionIndexFlagType {
    NOT_SET = "NOT_SET",
    ORDER_IN_WRONG_CONTRACT = "ORDER_IN_WRONG_CONTRACT",
    LARGE_PROFIT_IN_ONE_ORDER = "LARGE_PROFIT_IN_ONE_ORDER"
}